export default "__VITE_ASSET__B3r_zjys__"